import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogModule, MatDialogContent, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';

import { FormatCurrencyPipe, FormatFSECurrencyPipe, FseToFrDateFormat } from '@app/shared/pipes/format-currency.pipe';

import { switchMap, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

import { FseService, FactureSearcher, FacturePreteLot, StateHelper } from '../fse.service';
import { environment } from '../../../environments/environment';
import Swal from 'sweetalert2';

import * as fselib from 'mercalink-fselib'; 

export interface DetailDialogData {
	fSEOrder: fselib.FSEOrder,
  area_baseurl: string,
  numIdentFact: string,
  configarea?: fselib.ConfigArea;
}

@Component({
  selector: 'app-detail',
	standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatDialogContent, FormatCurrencyPipe, FormatFSECurrencyPipe, FseToFrDateFormat],
  templateUrl: './detail.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./detail.component.scss', '../fses/fses.component.scss'],
})

export class DetailComponent {
	readonly dialogRef = inject(MatDialogRef<DetailComponent>);
	readonly dialogdata:DetailDialogData = inject<DetailDialogData>(MAT_DIALOG_DATA as any);	// 'as any' tricks the compiler
	
	public prestations: fselib.PrestationFR[] = [];
	public factureFR!: fselib.FactureFR;
	
	constructor( private fseService: FseService, public stateHelper: StateHelper, private meklibService: fselib.MercalinkFselibService) {}
	
	ngOnInit(): void {
		if (this.dialogdata.fSEOrder.data.processingResult?.areaResponse?.HTTPResponse?.factureFR) {
			this.factureFR = this.dialogdata.fSEOrder.data.processingResult?.areaResponse?.HTTPResponse?.factureFR;
		}
		if (Array.isArray(this.dialogdata.fSEOrder.data.processingResult?.areaResponse?.HTTPResponse?.factureFR?.prestationFR)) {
			this.prestations = this.dialogdata.fSEOrder.data.processingResult?.areaResponse?.HTTPResponse?.factureFR?.prestationFR;
		} else {
			if (this.dialogdata.fSEOrder.data.processingResult?.areaResponse?.HTTPResponse?.factureFR?.prestationFR) {
				this.prestations.push(this.dialogdata.fSEOrder.data.processingResult?.areaResponse?.HTTPResponse?.factureFR?.prestationFR);
			}
		}
	}	
	
	forcerEtatFacture(is_override: boolean) {	// Update fse_roder.etat_facture. RSP <-> "PAYÉ_FORÇAGE"
		const etat_facture = (is_override ? "PAYÉ_FORÇAGE" : "RSP");
		const data= {"id":this.dialogdata.fSEOrder.id, "etat_facture": etat_facture};
		this.fseService.postFSEUpdateStateEvent$(environment.server_url, data)
			.subscribe({
			  next: () => {
			    console.log('postFSEUpdateStateEvent$ process completed successfully.');
			  },
			  error: (error:any) => {
			    console.error('Error in postFSEUpdateStateEvent$ process:', error);
			    Swal.fire({ icon: 'error', title: 'Erreur', text: error.message || 'Une erreur est survenue.' });
			  }
			});
	}

  /* Génération d'une DRE d'annulation via l'API creerDREAnnulation */
  genDREannul() {
    const dateFacture = fselib.tofseformat(this.dialogdata.fSEOrder.data.factureFR.dateFacture);
    this.meklibService.creerDREAnnulation$(this.dialogdata.area_baseurl, this.dialogdata.numIdentFact, this.dialogdata.fSEOrder.data.factureFR.numFacture, dateFacture, this.dialogdata.fSEOrder.data.factureFR.modeSecur, this.dialogdata?.configarea?.nomRessLect??'PCSC')
    .pipe(
      // switchMap handles the transition to the second call
      switchMap((areaResponse: fselib.AreaResponseType | undefined) => {
        // Check for business errors from the first API
        if (!areaResponse || areaResponse.HTTPResponse.codeRetour !== "0") {
          const errorMsg = areaResponse?.HTTPResponse.libRetour || "Réponse invalide de l'API";
          // throwError skips the next step and goes straight to the error block
          return throwError(() => new Error(errorMsg));
        }
        console.log('DRE d\'annulation créée avec succès. Mise à jour de la base de données...');
        
        return this.fseService.putAnnulDRE$(this.dialogdata.fSEOrder.id);
      })
    ).subscribe({
      next: () => {
        // Both calls succeeded
        console.log('FSE marquée comme annulée dans la DB: ', this.dialogdata.fSEOrder.data.factureFR.numFacture);
        Swal.fire({ icon: 'success', title: 'Succès', text: 'La DRE d\'annulation a été générée et la facture a été mise à jour.' });
      },
      error: (error: any) => {
        // Handles errors from either the first or second call
        console.error('[genDREannul] Erreur:', error);
        Swal.fire({ icon: 'error', title: 'Erreur', text: error.message || 'Une erreur est survenue lors de l\'annulation DRE.' });
      }
    });
  }
	
	aCharge(p: fselib.PrestationFR): number {
		let total = +(p.montantHonoraires??0);
		let amo:number = +(p.montantRemboursementAMO??0);
		let amc:number = +(p.montantRemboursementAMC??0);
		return total-amo-amc;
	}
	
	get totalACharge(): number {
		let total = +(this.factureFR?.totalFacture?.totalFacture??0);
		let amo:number = +(this.factureFR?.totalFacture?.totalRemboursableAmo??0);
		let amc:number = +(this.factureFR?.totalFacture?.totalRemboursableAmc??0);
		return total-amo-amc;
	}
	
	
}
